import React, { useCallback } from 'react'

import { twMerge } from 'tailwind-merge'

import { Icon, T, Tooltip } from 'src/govwell-ui'

type Props = {
  isCollapsed: boolean
  isEnabled: boolean
  onOpen: (() => void) | undefined
}

const AIAssistantHeaderButton = ({ isCollapsed, isEnabled, onOpen }: Props) => {
  const handleClick = useCallback(
    (e: React.MouseEvent | React.KeyboardEvent) => {
      e.preventDefault()
      e.stopPropagation()
      onOpen?.()
    },
    [onOpen]
  )

  if (!isEnabled || !onOpen) {
    return null
  }

  return (
    <Tooltip content={isCollapsed ? 'AI Assistant' : undefined} side="right">
      <button
        onClick={handleClick}
        className={twMerge(
          'group !flex h-8 w-full cursor-pointer items-center gap-3 rounded-lg bg-orange-50/50 px-3 py-1 ring-[0.5px] ring-orange-500/30 hover:bg-orange-500 hover:text-neutral-50 focus-visible:!outline-1 focus-visible:!outline-neutral-950 dark:bg-orange-950/30 dark:ring-orange-500/30 dark:hover:bg-orange-500 dark:hover:text-neutral-950 dark:focus-visible:!outline-neutral-50',
          isCollapsed ? 'max-w-[32px] min-w-[32px] p-[9px]' : ''
        )}
        style={{
          maxWidth: isCollapsed ? '32px' : 'auto',
          minWidth: isCollapsed ? '32px' : 'auto',
        }}
      >
        <Icon
          icon="FaSparkles"
          className="h-[20px] w-[20px] text-orange-700 group-hover:!text-neutral-50 dark:group-hover:!text-neutral-950"
        />
        {!isCollapsed && (
          <T.Body
            as="span"
            className="text-left font-medium text-orange-700 group-hover:!text-neutral-50 dark:group-hover:!text-neutral-950"
          >
            AI Assistant
          </T.Body>
        )}
      </button>
    </Tooltip>
  )
}

export default React.memo(AIAssistantHeaderButton)
